import React from 'react';

const SettingTheme = () => {
  return <div>SettingTheme</div>;
};

export default SettingTheme;
